import Box from '@mui/material/Box';
import * as Icon from '@mui/icons-material';
import { BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Field, Form, Formik, FormikHelpers } from 'formik';
import { TextField } from '@mui/material';
import MoneyFormatCustom from './components/MoneyFormatCustom';
import { InputSelect } from '../../../../shared/components/InputSelect';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import AutoCalculator from './components/AutoCalcular';
import ContaReceberController from '../../../../controllers/ContaReceberController';
import { ContasReceber } from '../../../../routes/RoutesNames';
import { toast } from 'react-toastify';

const parseMoney = (value: any): number => {
  if (typeof value === 'number') return value;
  if (!value) return 0;
  const cleanString = value.toString().replace(/[^\d,]/g, '').replace(',', '.');
  return parseFloat(cleanString) || 0;
};

interface ContasReceberLancamento {
  NumeroParcela: number | null;
  Totalizador: number | string;
  Parcelas1: string;
  Parcelas2: string;
  Dinheiro: number | string;
  Pix: number | string;
  vlrDeposito: number | string;
  ContaBancariaId: string;
  VlrCCredito1: number | string;
  VlrCCredito2: number | string;
  VlrCDebito1: number | string;
  VlrCDebito2: number | string;
  ValorParcela: number | string
  Bandeira1: string;
  Bandeira2: string;
  Bandeira3: string;
  Bandeira4: string;
}

export default function ContasReceberLancamento() {
  const location = useLocation();
  const codigoParcela = location.state?.codigoParcela || '';
  const valorParcela = location.state?.valorParcela || '';
  const { id } = useParams();
  const navigation = useNavigate();

  const [initialValues] = useState<ContasReceberLancamento>({
    Parcelas1: '', Parcelas2: '', Dinheiro: '0,00', Pix: '0,00', vlrDeposito: '0,00', Totalizador: '0,00', ContaBancariaId: '',
    VlrCCredito1: '0,00', VlrCCredito2: '0,00', VlrCDebito1: '0,00', VlrCDebito2: '0,00', NumeroParcela: codigoParcela,
    ValorParcela: valorParcela || '0,00', Bandeira1: '', Bandeira2: '', Bandeira3: '', Bandeira4: ''
  });

  const PARCELAS = [{ value: 1, label: '1x' }, { value: 2, label: '2x' }, { value: 3, label: '3x' }, { value: 4, label: '4x' }, { value: 5, label: '5x' }, { value: 6, label: '6x' }, { value: 7, label: '7x' }, { value: 8, label: '8x' }, { value: 9, label: '9x' }, { value: 10, label: '10x' }, { value: 11, label: '11x' }, { value: 12, label: '12x' }];
  const BANCOS = [{ value: 1, label: 'Bradesco' }, { value: 2, label: 'Banco do Brasil' }, { value: 3, label: 'Caixa' }, { value: 4, label: 'Santander' }, { value: 5, label: 'Sicoob' }];
  const BANDEIRAS = [{ value: 'Mastercard', label: 'Mastercard' }, { value: 'Visa', label: 'Visa' }];

  const handleSubmit = async (values: ContasReceberLancamento, actions: FormikHelpers<ContasReceberLancamento>) => {
    const payload = {
      ...values,
      TipoLancamento: 'L',
      origem: "contasReceber",
      codigo: id,
      Dinheiro: parseMoney(values.Dinheiro), vlrDeposito: parseMoney(values.vlrDeposito), Pix: parseMoney(values.Pix),
      Totalizador: parseMoney(values.Totalizador), VlrCCredito1: parseMoney(values.VlrCCredito1),
      VlrCCredito2: parseMoney(values.VlrCCredito2), VlrCDebito1: parseMoney(values.VlrCDebito1),
      VlrCDebito2: parseMoney(values.VlrCDebito2),
    }
    const response = await ContaReceberController.Salvar(payload);
    if (response.StatusCode === 204) {
      toast('Lançamento da parcela realizado!', { type: 'success' });
      navigation(ContasReceber);
    } else {
      toast('Erro ao fazer lançamento da parcela!', { type: 'error' });
    }
  };

  return (
    <Box sx={{ width: '100%', padding: 2 }}>
      <HeaderComponent text={'Lançamento'} className={'mb-5'} onClose={() => navigation(-1)} />

      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, isSubmitting, setFieldValue }) => {

          const totalCalculado = parseMoney(values.Totalizador);
          const valorDaParcela = parseMoney(values.ValorParcela);
          const valoresBatem = Math.abs(totalCalculado - valorDaParcela) < 0.01;

          return (
            <Box>
              <div className={'pb-2'}>
                <Form className={'grid grid-cols-1 md:grid-cols-12 gap-4'}>

                  <AutoCalculator values={values} setFieldValue={setFieldValue} />

                  <BoxButtons className={'col-span-1 md:col-span-12'}>
                    <Button variant='contained' onClick={() => window.history.back()} color='warning' startIcon={<Icon.ArrowBack />}>
                      Voltar
                    </Button>
                    <Button
                      type='submit'
                      variant='contained'
                      color='success'
                      startIcon={<Icon.Save />}
                      disabled={isSubmitting || !valoresBatem}
                    >
                      Salvar
                    </Button>
                  </BoxButtons>
                  <div className="col-span-12 md:col-span-3">
                    <Field name='NumeroParcela' disabled as={TextField} label='Número Parcela' fullWidth />
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <Field name='ValorParcela' disabled component={MoneyFormatCustom} label='Valor Parcela' fullWidth />
                  </div>
                  <div className="col-span-12 md:col-span-4">
                    <Field name='Totalizador' component={MoneyFormatCustom} label='Valor Total (Soma)' InputProps={{ readOnly: true }} key={`total-${values.Totalizador}`} fullWidth />
                  </div>

                  <div className="col-span-12 md:col-span-3">
                    <Field name='Dinheiro' component={MoneyFormatCustom} label='Dinheiro' fullWidth />
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <Field name='Pix' component={MoneyFormatCustom} label='Pix' fullWidth />
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <Field name='vlrDeposito' component={MoneyFormatCustom} label='Depósito' fullWidth />
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <InputSelect label='Conta Bancária' name='ContaBancariaId' size='medium' items={BANCOS} handleChange={handleChange} value={values.ContaBancariaId?.toString()} fullWidth />
                  </div>

                  <div className="col-span-12 md:col-span-3">
                    <Field name='VlrCDebito1' component={MoneyFormatCustom} label='Débito 1' fullWidth />
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <InputSelect label='Bandeira' name='Bandeira1' size='medium' items={BANDEIRAS} handleChange={handleChange} value={values.Bandeira1?.toString()} fullWidth />
                  </div>

                  <div className="col-span-12 md:col-span-3">
                    <Field name='VlrCDebito2' component={MoneyFormatCustom} label='Débito 2' fullWidth />
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <InputSelect label='Bandeira' name='Bandeira2' size='medium' items={BANDEIRAS} handleChange={handleChange} value={values.Bandeira2?.toString()} fullWidth />
                  </div>

                  <div className="col-span-12 md:col-span-3">
                    <Field name='VlrCCredito1' component={MoneyFormatCustom} label='Crédito 1' fullWidth />
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <InputSelect label='Parcelas' name='Parcelas1' size='medium' items={PARCELAS} handleChange={handleChange} value={values.Parcelas1?.toString()} fullWidth />
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <InputSelect label='Bandeira' name='Bandeira3' size='medium' items={BANDEIRAS} handleChange={handleChange} value={values.Bandeira3?.toString()} fullWidth />
                  </div>

                  <div className="col-span-12 md:col-span-3">
                    <Field name='VlrCCredito2' component={MoneyFormatCustom} label='Crédito 2' fullWidth />
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <InputSelect label='Parcelas' name='Parcelas2' size='medium' items={PARCELAS} handleChange={handleChange} value={values.Parcelas2?.toString()} fullWidth />
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <InputSelect label='Bandeira' name='Bandeira4' size='medium' items={BANDEIRAS} handleChange={handleChange} value={values.Bandeira4?.toString()} fullWidth />
                  </div>

                </Form>
              </div>
            </Box>
          );
        }}
      </Formik>
    </Box>
  );
}